import { Action } from '@ngrx/store';

import { AlarmChangedEvent } from '../../shared/events/alarm-changed.event';
import { AttributesChangedEvent } from '../../shared/events/attributes-changed.event';
import { BlindsChangedEvent } from '../../shared/events/blinds-changed.event';
import { ButtonPressedEvent } from '../../shared/events/button-pressed.event';
import { CurtainChangedEvent } from '../../shared/events/cutains-changed.event';
import { FanSpeedChangedEvent } from '../../shared/events/fanspeed-changed.event';
import { LightChangedEvent } from '../../shared/events/light-changed.event';
import { MediaStateChangedEvent } from '../../shared/events/media-state-changed.event';
import { MoodStartedChanged } from '../../shared/events/mood-started-changed.event';
import { ReservationStateChangedEvent } from '../../shared/events/reservation-state-changed.event';
import { RoomStateChangedEvent } from '../../shared/events/room-state-changed.event';
import { TemperatureChangedEvent } from '../../shared/events/temperature-changed.event';

export enum MessageActionTypes {
  TEMPERATURE_CHANGED = '[SignalR] Temperature',
  FANSPEED_CHANGED = '[SignalR] Fanspeed',
  ALARM_CHANGED = '[SignalR] Alarm',
  BLINDS_CHANGED = '[SignalR] Blinds',
  CURTAIN_CHANGED = '[SignalR] Curtain',
  LIGHT_CHANGED = '[SignalR] Light',
  MEDIA_STATE_CHANGED = '[SignalR] Media',
  BUTTON_PRESSED = '[SignalR] Button pressed',
  MOOD_STARTED = '[SignalR] Mood started',
  ROOM_STATE_CHANGED = '[SignalR] Room state changed',
  RESERVATION_STATE_CHANGED = '[SignalR] Reservation state changed',
  ATTRIBUTES_CHANGED = '[SignalR] Attributes changed',
}

export class TemperatureChanged implements Action {
  readonly type = MessageActionTypes.TEMPERATURE_CHANGED;
  constructor(public payload: TemperatureChangedEvent) {}
}

export class FanSpeedChanged implements Action {
  readonly type = MessageActionTypes.FANSPEED_CHANGED;
  constructor(public payload: FanSpeedChangedEvent) {}
}

export class AlarmChanged implements Action {
  readonly type = MessageActionTypes.ALARM_CHANGED;
  constructor(public payload: AlarmChangedEvent) {}
}

export class BlindsChanged implements Action {
  readonly type = MessageActionTypes.BLINDS_CHANGED;
  constructor(public payload: BlindsChangedEvent) {}
}

export class CurtainChanged implements Action {
  readonly type = MessageActionTypes.CURTAIN_CHANGED;
  constructor(public payload: CurtainChangedEvent) {}
}

export class LightChanged implements Action {
  readonly type = MessageActionTypes.LIGHT_CHANGED;
  constructor(public payload: LightChangedEvent) {}
}

export class MediaStateChanged implements Action {
  readonly type = MessageActionTypes.MEDIA_STATE_CHANGED;
  constructor(public payload: MediaStateChangedEvent) {}
}

export class ButtonPressed implements Action {
  readonly type = MessageActionTypes.BUTTON_PRESSED;
  constructor(public payload: ButtonPressedEvent) {}
}

export class MoodStarted implements Action {
  readonly type = MessageActionTypes.MOOD_STARTED;
  constructor(public payload: MoodStartedChanged) {}
}

export class RoomStateChanged implements Action {
  readonly type = MessageActionTypes.ROOM_STATE_CHANGED;
  constructor(public payload: RoomStateChangedEvent) {}
}

export class ReservationStateChanged implements Action {
  readonly type = MessageActionTypes.RESERVATION_STATE_CHANGED;
  constructor(public payload: ReservationStateChangedEvent) {}
}

export class AttributesChanged implements Action {
  readonly type = MessageActionTypes.ATTRIBUTES_CHANGED;
  constructor(public payload: AttributesChangedEvent) {}
}

export type SignalRActions =
  | TemperatureChanged
  | FanSpeedChanged
  | AlarmChanged
  | CurtainChanged
  | BlindsChanged
  | LightChanged
  | MediaStateChanged
  | MoodStarted
  | RoomStateChanged
  | ButtonPressed
  | ReservationStateChanged
  | AttributesChanged;
